import type { IBarsSlice, } from "@store/bars/types";
import type { IEscrowSlice, } from "@store/escrow/types";
import type { IMessagesSlice, } from "@store/messages/types";
import type { INotificationsSlice, } from "@store/notifications/types";
import type { IPlatformSlice, } from "@store/platform/types";
import type { IPricingSlice, } from "@store/pricing/types";
import type { IReferralsSlice, } from "@store/referrals/types";
import type { ISettingsSlice, } from "@store/settings/types";
import type { ISwapSlice, } from "@store/swap/types";
import type { IUISlice, } from "@store/ui/types";
import type { IVaultsSlice, } from "@store/vaults/types";
import type { IWalletSlice, } from "@store/wallet/types";
import type { IWrapSlice, } from "@store/wrap/types";
import type { Draft, } from "immer";



export declare type IBracketStoreProps = {
	ready: boolean;
	fetching: boolean;
}


export declare type IBracketStoreActions = {
	fetch: () => Promise<void>;
	reset: () => void;
	resetAsync: () => Promise<void>;
}


export declare type IBracketStoreSlice = IBracketStoreProps & IBracketStoreActions;


export declare type IBracketStore = {
	bars: IBarsSlice;
	wallet: IWalletSlice;
	vaults: IVaultsSlice;
	platform: IPlatformSlice;
	ui: IUISlice;
	swap: ISwapSlice;
	notificationSlice: INotificationsSlice;
	msg: IMessagesSlice;
	pricing: IPricingSlice;
	settings: ISettingsSlice;
	referrals: IReferralsSlice;
	escrow: IEscrowSlice;
	wrap: IWrapSlice;
}


export declare type StoreGetter = (state?: IBracketStore) => IBracketStore;


export declare type StoreSetter = ( updater: (state: Draft<IBracketStore>) => void ) => void;


export const isIBracketStoreSlice = ( slice: unknown, ): slice is IBracketStoreSlice => {
	return typeof slice === 'object' && slice !== null && 'ready' in slice && typeof slice.ready === 'boolean' && 'fetch' in slice && typeof slice.fetch === 'function';
};


export type { IBarsProps, ILeaderboardProps, IPointsProps, IWalletPointsProps, LeaderboardEntry, } from "./bars/types";


export type { IPlatformProps, } from "./platform/types";


export type { ISwapProps, } from "./swap/types";


export type { IVaultsProps, } from "./vaults/types";


export * from "./vaults/types";
